export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="about-page">
      <div className="text-xs uppercase tracking-widest font-semibold text-[#B91C1C] mb-2">Who We Are</div>
      <h1 className="font-display text-5xl font-bold mb-6">About EverGro eMart</h1>
      <p className="text-lg text-[#334155] leading-relaxed mb-6">
        EverGro eMart is India's most transparent premium hamper e-commerce platform. We curate premium grocery hampers and reward our members through an simple 8-tier rewards program with timely payouts and clear rules.
      </p>
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        <div className="card-soft p-6">
          <div className="text-3xl font-numbers font-bold text-[#DC2626]">50K+</div>
          <div className="text-sm text-[#334155] mt-1">Active members across India</div>
        </div>
        <div className="card-soft p-6">
          <div className="text-3xl font-numbers font-bold text-[#DC2626]">₹12Cr+</div>
          <div className="text-sm text-[#334155] mt-1">Paid out in commissions</div>
        </div>
        <div className="card-soft p-6">
          <div className="text-3xl font-numbers font-bold text-[#7F1D1D]">99.8%</div>
          <div className="text-sm text-[#334155] mt-1">On-time delivery rate</div>
        </div>
      </div>
      <div className="mt-12 card-soft p-8">
        <h2 className="font-display text-2xl font-bold mb-3">Our Mission</h2>
        <p className="text-[#334155] leading-relaxed">
          To create wealth opportunities for ordinary Indians through premium product purchases and a fair, transparent rewards program.
        </p>
      </div>
    </div>
  );
}
